import { render } from "./leave-reports.vue?vue&type=template&id=c58e6280"
import script from "./leave-reports.vue?vue&type=script&lang=js"
export * from "./leave-reports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__